const BASE_URL = "https://powerful-pink-fly.cyclic.app/"

export default BASE_URL